<div class="language-modal-container">
  <div class="language-modal-content">
    <div class="language-modal-title">{{ "USER_NAVBAR.4" | translate }}</div>
    <div class="language-modal-description">
      {{ "USER_NAVBAR.5" | translate }}
    </div>
    <form class="selector-container" [formGroup]="FormLanguage">
      <label for="">{{ "USER_NAVBAR.11" | translate }}</label>
      <!-- <ng-select
        class="language-select"
        [placeholder]="
          'comercial.clients.detail_client.operativeZonePlaceHolder' | translate
        "
        [items]="LanguageList"
        bindLabel="name"
        bindValue="id"
        formControlName="LanguageCode"
        [multiple]="false"
      >
      </ng-select> -->
      <div class="dropdown-container">
        <app-custom-dropdown
          [dataArray]="LanguageList"
          [bindName]="'name'"
          [bindIcon]="'icon'"
          [bindValue]="'id'"
          [selectedObject]="SelectedLanguage"
          [showAbsolute]="false"
          (optionEmitter)="changeLanguage($event)"
        ></app-custom-dropdown>
      </div>
    </form>
  </div>
  <div class="modal-footer-container">
    <div class="button-white button-padding-10 button-text" (click)="close()">
      {{ "USER_NAVBAR.6" | translate }}
    </div>
    <div class="button-green button-padding-10 button-text" (click)="save()">
      {{ "USER_NAVBAR.7" | translate }}
    </div>
  </div>
</div>
